<template>
	<div>
		<title-bar :title-stack="titleStack"/>

		<section class="section is-main-section">
			<card-component title="" icon="">
				<b-field label="カテゴリ名"
					horizontal
					custom-class="require"
					:type="{ 'is-danger': $utils.hasError(errors, 'name') }"
					:message="errors.name">
					<b-input type="text" v-model="name" />
				</b-field>

				<b-field label="カラー" horizontal>
					<chrome v-model="color"></chrome>
				</b-field>

				<b-field class="mt-40" horizontal>
					<div>
						<b-button @click="$router.go(-1)">戻る</b-button>
						<b-button type="is-primary" class="ml-50" :loading="isLoading" @click="onSubmitClick">{{ !id ? '登録' : '更新' }}</b-button>
					</div>
				</b-field>
			</card-component>
		</section>
	</div>
</template>

<style lang="scss" scoped>
.vc-compact {
	padding-left: 0;
}
</style>

<script>
import TitleBar from '@/components/TitleBar'
import CardComponent from '@/components/CardComponent'
import mapValues from 'lodash/mapValues'
import CheckboxPicker from '@/components/CheckboxPicker'
import RadioPicker from '@/components/RadioPicker'
import ImagePicker from '@/components/ImagePicker'
import DatePicker from '@/components/DatePicker'
import { Chrome } from 'vue-color'

export default {
	name: 'Forms',
	components: {
		ImagePicker,
		RadioPicker,
		CheckboxPicker,
		CardComponent,
		TitleBar,
		DatePicker,
		Chrome,
	},
	data () {
		return {
			id: '',
			name: '',
			color: '',
			errors: {
				name: '',
			},
			isLoading: false,
		}
	},
	computed: {
		titleStack () {
			return [
				'カテゴリ登録',
			]
		}
	},
	mounted() {
		this.init();
	},
	methods: {
		onSubmitClick: async function() {
			for (let key in this.errors) {
				this.errors[key] = '';
			}

			this.isLoading = true;
			let data = {
				"id": this.id,
				"name": this.name,
				"color": this.$utils.isObject(this.color) ? this.color.hex : this.color,
			};

			this.$utils.log(data);

			try {
				let ep = 'categories';
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.$utils.toastSuccess('データを更新しました');
				this.$router.push({ name: 'category' });
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
				if (error.response.status === 400) {
					let details = error.response.data.details;
					for (let key in details) {
						this.errors[this.$utils.toCamelCase(key)] = details[key];
					}
				}
			} finally {
				this.isLoading = false;
			}
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			let loader = this.$buefy.loading.open();
			let params = this.$route.params.categoryId ? '/' + this.$route.params.categoryId: '';
			let ep = 'categories/screen' + params;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.id = res.data.id;
				this.name = res.data.name;
				this.color = res.data.color;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
	}
}
</script>
